import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { requestMagicLink } from '../../api/api';
import { DisplayHeading } from '../editorial';
import EditorialAuthShell from '../EditorialAuthShell/EditorialAuthShell';

const RequestLogin: React.FC = () => {
  const location = useLocation();
  const [status, setStatus] = useState<'sending' | 'sent' | 'error'>('sending');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email');

    if (email) {
      requestMagicLink(email)
        .then(() => setStatus('sent'))
        .catch((error) => {
          console.error('Error requesting magic link:', error);
          setStatus('error');
        });
    } else {
      setStatus('error');
    }
  }, [location.search]);

  const heading =
    status === 'sent' ? 'Check your email' : status === 'error' ? 'Something went wrong' : 'Sending your link';
  const body =
    status === 'sent'
      ? 'A sign-in link is on its way. Open it on this device to continue.'
      : status === 'error'
      ? 'We couldn\'t send your sign-in link. Please head back and try again.'
      : 'One moment while we send your sign-in link.';

  return (
    <EditorialAuthShell bloomSeed={2}>
      <DisplayHeading as="h1" scale="heading" measure={false} className="text-center">
        {heading}
      </DisplayHeading>
      <p className="mt-4 text-editorial-body text-editorial-muted/70">{body}</p>
    </EditorialAuthShell>
  );
};

export default RequestLogin;
